import { ConfigService } from 'vimmi-web-utils/cjs/configService';
import { localStore } from 'vimmi-web-utils/cjs/localStore';
import { screenMode } from 'vimmi-web-utils/cjs/screenMode';
import { doFetch } from 'vimmi-web-utils/cjs/doFetch';
import { getCurrentProtocol } from 'vimmi-web-utils/cjs/getCurrentProtocol';
import { normDomain } from 'vimmi-web-utils/cjs/normDomain';
import { deviceAsync } from 'vimmi-web-utils/cjs/deviceAsync';
import { StyledLogger } from 'vimmi-web-utils/cjs/logger';
import { normalizeLang } from 'vimmi-web-utils/cjs/normalizeLang';

var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (Object.prototype.hasOwnProperty.call(b, p))
                d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Config = new ConfigService();

var Buffer = /** @class */ (function () {
    function Buffer() {
        this._eventsBuffer = [];
    }
    Buffer.prototype.putInbBuffer = function (eventArg) {
        this._eventsBuffer.push(eventArg);
    };
    Buffer.prototype.send = function () {
    };
    Buffer.prototype.freeBuffer = function () {
        if (this._eventsBuffer.length) {
            var buffer = __spreadArray([], this._eventsBuffer, true);
            this._eventsBuffer = [];
            while (buffer.length) {
                var eventArg = buffer.shift();
                this.send.apply(this, eventArg);
            }
        }
    };
    return Buffer;
}());

/** List of all available events types*/
// export const EVENT_TYPES = {
//     APP: 'app',
//     MEDIA: 'media',
//     //  AMS: 'ams',
//     //  CDN: 'cdn',
//     AD: 'advertising',
// };
// export class SDKError extends Error {
//     public err_name: string;
//     public err_code: number;
//
//     constructor(args: any) {
//         super(args);
//     }
// }
//
// export const ERROR_CODES = {
//     6: {
//         name: 'INTERNAL',
//         description: 'The SDK internal error',
//     },
//     4: {
//         name: 'NETWORK',
//         description: 'The browser doesn\'t supports!',
//     },
//     5: {
//         name: 'SERVER',
//         description: 'Server error',
//     },
//     7: {
//         name: 'BROWSER',
//         description: 'The browser doesn\'t supports!',
//     },
// };
/** FBQ */
var FBQ_EVENTS_MAP = {
    'PageView': 'track',
    'Purchase': 'track',
};
/** GTM */
var GTM_EVENTS_MAP = {
    'UserRegistered': 'gtm.user_registered',
    'videoStart': 'video_start',
    'videoProgress': 'video_progress',
    'videoComplete': 'video_complete',
};
/** BUH **/
var BUH_EVENTS_MAP = {
    'app_open': 'app',
    'app_ready': 'app',
    'app_paused': 'app',
    'app_closed': 'app',
    'app_error': 'app',
    'auth_sent': 'app',
    'sync_sent': 'app',
    'screen_request': 'app',
    'play_request': 'app',
    'auth_ok': 'app',
    'auth_error': 'app',
    'sync_ok': 'app',
    'sync_error': 'app',
    'screen_ready': 'app',
    'page_elem_shown': 'app',
    'play_response': 'app',
    'play_error': 'app',
    'try_play_premium': 'app',
    'sid_create': 'app',
    'ams_request': 'app',
    'ams_response': 'app',
    'item_related': 'app',
    'purchase': 'app',
    'recommendation': 'app',
    'app_hidden': 'app',
    'app_shown': 'app',
    'screen_response': 'app',
    'popup_shown': 'app',
    'popup_clicked': 'app',
    'banner_click': 'app',
    'fungus_login_attempt': 'app',
    'fungus_login_success': 'app',
    'user_interaction': 'app',
    'share_item': 'app',
    'external_application_opened': 'app',
    'products_updated': 'app',
    'favorite_item': 'app',
    'unfavorite_item': 'app',
    'product_offer_played_on': 'app',
    'search': 'app',
    'notification_recieved': 'app',
    'notification_action': 'app',
    'set_pn_permission': 'app',
    'fungus_login_failure': 'app',
    'fungus_logout_attempt': 'app',
    'fungus_logout_success': 'app',
    'fungus_logout_failure': 'app',
    'first_run': 'app',
    'upgrade': 'app',
    'in_box_open': 'app',
    'legal_terms_accepted': 'app',
    'ad_show': 'advertising',
    'ad_skip': 'advertising',
    'ad_ignored': 'advertising',
    'ad_clicked': 'advertising',
    'ad_request': 'advertising',
    'ad_vast_event': 'advertising',
    'ad_canceled': 'advertising',
    'meta_request': 'media',
    'meta_response': 'media',
    'meta_error': 'media',
    'player_ready': 'media',
    'media_is_playing': 'media',
    'start': 'media',
    'chu': 'media',
    'seek': 'media',
    'stop': 'media',
    'abort': 'media',
    'media_buffering_start': 'media',
    'media_buffering_completed': 'media',
    'media_error': 'media',
    'media_is_playineg': 'media',
    'media_pause': 'media',
    'media_resume': 'media',
    'media_bitrate_switch': 'media',
    'media_audio_switch': 'media',
    'media_subtitle_switch': 'media',
    'media_screen_switch': 'media',
    'media_cast': 'media',
    'dl_start': 'media',
    'dl_pause': 'media',
    'dl_error': 'media',
    'dl_completed': 'media',
};
/** Shoprz **/
var SHOPRZ_EVENTS_MAP = {
    'session_start': 'system',
    'registration': 'system',
    'login': 'system',
    'is_alive': 'system',
    'add_to_cart': 'commerce',
    'remove_from_cart': 'commerce',
    'buy_now': 'commerce',
    'checkout_clicked': 'commerce',
    'checkout_finished ': 'commerce',
    'product_return': 'commerce',
    'add_wishlist': 'user_preferences',
    'remove_wishlist': 'user_preferences',
    'commented': 'user_preferences',
    'review': 'user_preferences',
    'channel_follow': 'user_preferences',
    'channel_unfollow': 'user_preferences',
    'chat_message_sent': 'user_preferences',
    'chat_emoji_sent': 'user_preferences',
    'share': 'user_preferences',
    'notify_on': 'user_preferences',
    'start': 'player',
    'watch': 'player',
    'seek': 'player',
    'pause': 'player',
    'heartbeat': 'player',
    'object_click': 'navigation',
    'page_opened': 'navigation',
    'search_request': 'search',
    'search_chosen': 'search',
};

var $logger = new StyledLogger('VimmiAI', {
    debug: {
        active: true,
        level: StyledLogger.TRACE_LEVEL
    }
});

var BuhDriver = /** @class */ (function () {
    function BuhDriver(constructorOptions) {
        if (constructorOptions === void 0) { constructorOptions = {}; }
        this.$logger = $logger.cl('BuhDriver', false);
        this._buffer = [];
        this._packageInterval = null;
        this.packaging = true;
        this.options = { ep: null };
        this.defaultPackageOptions = {
            minEvents: 40,
            maxEvents: 50
        };
        if (constructorOptions && constructorOptions.storageKey) {
            this.storageKey = constructorOptions.storageKey;
        }
        else {
            this.storageKey = 'buhEventsBuffer';
        }
        if (localStore.get(this.storageKey)) {
            try {
                this._buffer = JSON.parse(localStore.get(this.storageKey));
            }
            catch (e) {
                this.$logger.warn('cannot parse evens buffer from localStorage!');
            }
        }
    }
    BuhDriver.prototype.buhDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = "".concat(Config.get('app_id') || 'vimmi.' + this.deviceType, ", ");
                        return [4 /*yield*/, deviceAsync.getBrowserName()];
                    case 1:
                        _b = _a + ((_c.sent()) ||
                            'unknown') + ", AppVersion: ".concat(Config.get('app_version') || '0.0.0', ", ");
                        return [4 /*yield*/, deviceAsync.getOsVersion()];
                    case 2: return [2 /*return*/, _b + ((_c.sent()) ||
                            'unknown') + ", Language: ".concat(Config.get('language') || 'unknown')];
                }
            });
        });
    };
    Object.defineProperty(BuhDriver.prototype, "deviceType", {
        get: function () {
            return Config.get('platform') || 'web';
        },
        enumerable: false,
        configurable: true
    });
    BuhDriver.prototype.applyConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Config.get('drivers.buh.buhsy') === false) {
                    this.disablePackaging();
                }
                else {
                    if (Config.get('drivers.buh.package')) {
                        this.enablePackaging();
                    }
                    else {
                        this.disablePackaging();
                    }
                }
                return [2 /*return*/, true];
            });
        });
    };
    BuhDriver.prototype.enablePackaging = function () {
        var _this = this;
        this.packaging = true;
        var prevInterval = this.options.egap;
        this.options = Object.assign({ packageOpt: this.defaultPackageOptions }, Config.get('drivers.buh') || {});
        if (this._packageInterval && prevInterval === Config.get('drivers.buh.egap')) {
            // the same interval already initialized
            return;
        }
        if (this._packageInterval) {
            this.destroyPackageInterval();
        }
        if (this.options.egap) {
            this.$logger.log('initialize package listener', this.options.egap);
            this._packageInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.$logger.log('send package by interval');
                            return [4 /*yield*/, this.handlePackage({ package: true })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, this.options.egap * 1000);
        }
    };
    BuhDriver.prototype.disablePackaging = function () {
        this.packaging = false;
        this.destroyPackageInterval();
    };
    BuhDriver.prototype.destroyPackageInterval = function () {
        if (this._packageInterval) {
            clearInterval(this._packageInterval);
            this._packageInterval = null;
        }
    };
    BuhDriver.prototype.prepareEventData = function (evn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var eventType, data, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        eventType = BUH_EVENTS_MAP[evn];
                        _b = {
                            evn: evn,
                            etype: eventType,
                            ts: Config.get('drivers.buh.timeFormat') === 'ms' ? Date.now() : Date.now() / 1000
                        };
                        return [4 /*yield*/, deviceAsync.connectionType()];
                    case 1:
                        _b.network = _c.sent(),
                            _b.version = Config.get('sdk_version'),
                            // app_info: (Config.get('app_info') || ""),
                            // app_version: `${Config.get('version')}`,
                            // customer: Config.get('customer'),
                            _b.device_type = this.deviceType,
                            /** THERE ARE NO ANY SENSE TO DO THAT MORE*/
                            // device_id: (this.deviceType || '').toLowerCase() === 'web' ? `${Config.get('device_id')}_web_${this.customDeviceIdPart}` : Config.get('device_id'),
                            _b.device_id = Config.get('device_id'),
                            _b.screen_mode = screenMode();
                        return [4 /*yield*/, deviceAsync.getOsName()];
                    case 2:
                        _a = ((_c.sent()) || 'unknown') + ':';
                        return [4 /*yield*/, deviceAsync.getOsVersion()];
                    case 3:
                        _b.device_os = _a + ((_c.sent()) || 'unknown'),
                            _b.language = Config.get('language');
                        return [4 /*yield*/, this.buhDeviceInfo()];
                    case 4:
                        data = (_b.device_info = _c.sent(),
                            _b);
                        if (options.buffer_timestamp) {
                            data.ts = Config.get('drivers.buh.timeFormat') === 'ms' ? options.buffer_timestamp : options.buffer_timestamp / 1000;
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    BuhDriver.prototype.handlePackage = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Config.get('drivers.buh.buhsy') === false) {
                            return [2 /*return*/, null];
                        }
                        if (!this._buffer.length) return [3 /*break*/, 2];
                        this.$logger.p('handlePackage').log('buffer:', __spreadArray([], this._buffer, true));
                        localStore.set(this.storageKey, []);
                        return [4 /*yield*/, this.sendToBackend(this._buffer.splice(0, this.options.packageOpt.maxEvents), options)];
                    case 1:
                        res = _a.sent();
                        this.$logger.p('handlePackage')
                            .log('events that remained in the buffer:', this._buffer.length, __spreadArray([], this._buffer, true), res);
                        return [2 /*return*/, res];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BuhDriver.prototype.sendToBackend = function (eventData, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, blob, res;
            var _this = this;
            return __generator(this, function (_a) {
                if (Config.get('drivers.buh.buhsy') === false) {
                    return [2 /*return*/, null];
                }
                options = options || {};
                url = this.formatBackendUrl(options.package ? 'package' : eventData.evn, !!options.package);
                if (options.beacon && navigator.sendBeacon && !Config.get('drivers.buh.headers')) {
                    this.$logger.p('sendToBackend beacon')
                        .debug("Sending ".concat(options.package ? 'package' : '', " as beacon, events: \n").concat(JSON.stringify(eventData, null, ' ')));
                    blob = new Blob([JSON.stringify(eventData)], {
                        type: 'text/plain; charset=UTF-8'
                    });
                    res = navigator.sendBeacon(url, blob);
                    this.$logger.p('sendToBackend beacon').info("beacon res", res);
                    return [2 /*return*/, res];
                }
                else {
                    this.$logger.p('sendToBackend fetch')
                        .info("Sending ".concat(options.package ? 'package' : '', " events: \n").concat(JSON.stringify(eventData, null, ' ')));
                    return [2 /*return*/, doFetch(url, {
                            headers: Config.get('drivers.buh.headers') || {},
                            method: 'post',
                            keepalive: true,
                            body: JSON.stringify(eventData)
                        })
                            .then(function (result) {
                            return true;
                        })
                            .catch(function (error) {
                            if (Config.get('debug')) {
                                _this.$logger.p('sendToBackend fetch').error(error);
                            }
                            throw error;
                        })];
                }
            });
        });
    };
    BuhDriver.prototype.send = function (event, extra_data, options) {
        if (extra_data === void 0) { extra_data = null; }
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var eventData, _a, _b, _c, mapOpt, key, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (Config.get('drivers.buh.buhsy') === false) {
                            return [2 /*return*/];
                        }
                        if (!BUH_EVENTS_MAP[event]) {
                            this.$logger.p('send').warn("the \"BuhDriver\" driver doesn't support this event: ".concat(event));
                            return [2 /*return*/, false];
                        }
                        options = options || {};
                        _b = (_a = Object).assign;
                        _c = [{}];
                        return [4 /*yield*/, this.prepareEventData(event, options)];
                    case 1:
                        eventData = _b.apply(_a, _c.concat([_d.sent(), extra_data]));
                        if (Config.get('drivers.buh.mapOptions')) {
                            mapOpt = Config.get('drivers.buh.mapOptions');
                            for (key in mapOpt) {
                                if (eventData[key]) {
                                    eventData[mapOpt[key]] = eventData[key];
                                    delete eventData[key];
                                }
                            }
                        }
                        if (!this.packaging) return [3 /*break*/, 5];
                        this._buffer.push(eventData);
                        if (!(this._buffer.length >= this.options.packageOpt.minEvents || options.beacon)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handlePackage(__assign({ package: true }, options))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result];
                    case 3:
                        localStore.set(this.storageKey, JSON.stringify(this._buffer));
                        _d.label = 4;
                    case 4: return [2 /*return*/, {
                            buffered: true
                        }];
                    case 5: return [2 /*return*/, this.sendToBackend(eventData, options)];
                }
            });
        });
    };
    BuhDriver.prototype.beforePageClose = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.packaging && Config.get('drivers.buh.buhsy') !== false) {
                    this.$logger.p('beforePageClose').log('buffer:', __spreadArray([], this._buffer, true));
                    return [2 /*return*/, this.handlePackage(Object.assign({ beacon: true, fetch: false, package: true }, options))];
                }
                return [2 /*return*/, null];
            });
        });
    };
    BuhDriver.prototype.formatBackendUrl = function (evn, isPackage) {
        var url = "".concat(getCurrentProtocol(), "//").concat(normDomain(Config.get('drivers.buh.ep'))).concat(Config.get('drivers.buh.customPath') || '/event/evn/');
        return url + (Config.get('NODE_ENV') === 'development' && !isPackage && !Config.get('drivers.buh.customPath') ? "?evn=".concat(evn) : '');
    };
    BuhDriver.prototype.destroy = function () {
        this.disablePackaging();
    };
    return BuhDriver;
}());

var FBQDriver = /** @class */ (function () {
    function FBQDriver() {
        this.currentPixelId = null;
        this.fbq = null;
    }
    FBQDriver.prototype.applyConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Config.get('drivers.fbq.pixelId')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadSdk()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 2];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    FBQDriver.prototype.send = function (event, extra_data, options) {
        if (!FBQ_EVENTS_MAP[event]) {
            return false;
        }
        var eventType = FBQ_EVENTS_MAP[event];
        var eventData = Object.assign({}, extra_data || {});
        if (Object.values(eventData).length) {
            this.fbq(eventType, event, eventData);
        }
        else {
            this.fbq(eventType, event);
        }
        return true;
    };
    FBQDriver.prototype.loadSdk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        // @ts-ignore
                        if (window.fbq) {
                            // @ts-ignore
                            _this.fbq = window.fbq;
                            return;
                        }
                        if (_this.fbq && (_this.currentPixelId && _this.currentPixelId === Config.get('drivers.fbq.pixelId')))
                            return;
                        _this.currentPixelId = Config.get('drivers.fbq.pixelId');
                        var $this = _this;
                        // @ts-ignore
                        _this.fbq = window.fbq = function () {
                            $this.fbq.callMethod ? $this.fbq.callMethod.apply($this.fbq, arguments) : $this.fbq.queue.push(arguments);
                        };
                        // @ts-ignore
                        if (!window._fbq)
                            window._fbq = _this.fbq;
                        _this.fbq.push = _this.fbq;
                        _this.fbq.loaded = true;
                        _this.fbq.version = '2.0';
                        _this.fbq.queue = [];
                        var script = document.createElement('script');
                        script.async = true;
                        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
                        var head = document.getElementsByTagName('script')[0];
                        head.parentNode.insertBefore(script, head);
                        script.onload = function (event) {
                            _this.onLoaded();
                            resolve(true);
                        };
                        script.onerror = function (event) {
                            resolve(false);
                        };
                    })];
            });
        });
    };
    FBQDriver.prototype.onLoaded = function () {
        this.fbq('init', Config.get('drivers.fbq.pixelId'));
    };
    FBQDriver.prototype.destroy = function () {
    };
    return FBQDriver;
}());

var GTMDriver = /** @class */ (function () {
    function GTMDriver() {
        this.gtmId = null;
    }
    GTMDriver.prototype.applyConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Config.get('drivers.gtm.tagId')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadSdk()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 2];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    GTMDriver.prototype.send = function (event, extra_data, options) {
        if (!GTM_EVENTS_MAP[event]) {
            return false;
        }
        var eventType = GTM_EVENTS_MAP[event];
        var eventData = Object.assign({}, extra_data || {});
        // @ts-ignore
        window['dataLayer'].push(__assign({ event: eventType }, eventData));
        return true;
    };
    GTMDriver.prototype.loadSdk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        if ((_this.gtmId && _this.gtmId === Config.get('drivers.gtm.tagId')))
                            return;
                        _this.gtmId = Config.get('drivers.gtm.tagId');
                        // @ts-ignore
                        window['dataLayer'] = window['dataLayer'] || [];
                        // @ts-ignore
                        window['dataLayer'].push({
                            'gtm.start': new Date().getTime(), event: 'gtm.js'
                        });
                        // @ts-ignore
                        window['dataLayer'].push(['config', _this.gtmId, {
                                'cookie_flags': 'samesite=none;secure'
                            }]);
                        var script = document.createElement('script');
                        script.async = true;
                        script.src = 'https://www.googletagmanager.com/gtm.js?id=' + _this.gtmId;
                        document.getElementsByTagName('head')[0].appendChild(script);
                        script.onload = function (event) {
                            resolve(true);
                        };
                        script.onerror = function (event) {
                            resolve(false);
                        };
                    })];
            });
        });
    };
    GTMDriver.prototype.destroy = function () {
    };
    return GTMDriver;
}());

var ShoprzDriver = /** @class */ (function () {
    function ShoprzDriver(constructorOptions) {
        if (constructorOptions === void 0) { constructorOptions = {}; }
        this.$logger = $logger.cl('ShoprzDriver', false);
        this._buffer = [];
        this._packageInterval = null;
        this.packaging = true;
        this.options = { ep: null };
        this.defaultPackageOptions = {
            minEvents: 40,
            maxEvents: 50
        };
        if (constructorOptions && constructorOptions.storageKey) {
            this.storageKey = constructorOptions.storageKey;
        }
        else {
            this.storageKey = 'shoprzEventsBuffer';
        }
        if (localStore.get(this.storageKey)) {
            try {
                this._buffer = JSON.parse(localStore.get(this.storageKey));
            }
            catch (e) {
                this.$logger.warn('cannot parse evens buffer from localStorage!');
            }
        }
    }
    ShoprzDriver.prototype.shoprzDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = "".concat(Config.get('app_id') || 'vimmi.' + (Config.get('platform') || 'web'), ", ");
                        return [4 /*yield*/, deviceAsync.getBrowserName()];
                    case 1:
                        _b = _a + ((_c.sent()) ||
                            'unknown') + ", AppVersion: ".concat(Config.get('app_version') || '0.0.0', ", ");
                        return [4 /*yield*/, deviceAsync.getOsVersion()];
                    case 2: return [2 /*return*/, _b + ((_c.sent()) ||
                            'unknown') + ", Language: ".concat(Config.get('language') || 'unknown')];
                }
            });
        });
    };
    ShoprzDriver.prototype.deviceType = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deviceAsync.isAnyMobile()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 2];
                        return [2 /*return*/, 'mob'];
                    case 2: return [4 /*yield*/, deviceAsync.isTablet()];
                    case 3:
                        if (_a.sent()) {
                            return [2 /*return*/, 'tab'];
                        }
                        else if (deviceAsync.isSmartTv()) {
                            return [2 /*return*/, 'stv'];
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/, 'web'];
                }
            });
        });
    };
    ShoprzDriver.prototype.applyConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Config.get('drivers.shoprz.package')) {
                    this.enablePackaging();
                }
                else {
                    this.disablePackaging();
                }
                return [2 /*return*/, true];
            });
        });
    };
    ShoprzDriver.prototype.enablePackaging = function () {
        var _this = this;
        this.packaging = true;
        var prevInterval = this.options.egap;
        this.options = Object.assign({ packageOpt: this.defaultPackageOptions }, Config.get('drivers.shoprz') || {});
        if (this._packageInterval && prevInterval === Config.get('drivers.shoprz.egap')) {
            // the same interval already initialized
            return;
        }
        if (this._packageInterval) {
            this.destroyPackageInterval();
        }
        if (this.options.egap) {
            this.$logger.log('initialize package listener', this.options.egap);
            this._packageInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.$logger.log('send package by interval');
                            return [4 /*yield*/, this.handlePackage({ package: true })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, this.options.egap * 1000);
        }
    };
    ShoprzDriver.prototype.disablePackaging = function () {
        this.packaging = false;
        this.destroyPackageInterval();
    };
    ShoprzDriver.prototype.destroyPackageInterval = function () {
        if (this._packageInterval) {
            clearInterval(this._packageInterval);
            this._packageInterval = null;
        }
    };
    ShoprzDriver.prototype.prepareEventData = function (evn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var connectionType, data, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        return [4 /*yield*/, deviceAsync.connectionType()];
                    case 1:
                        connectionType = _c.sent();
                        if (connectionType === 'unavailable') {
                            connectionType = 'unknown';
                        }
                        _b = {
                            event: evn,
                            ts: Config.get('drivers.shoprz.timeFormat') === 'ms' ? Date.now() : Date.now() / 1000,
                            // ts: (Config.get('drivers.shoprz.timeFormat') === 'ms' ? Date.now() : Date.now() / 1000).toString(),
                            network: connectionType,
                            application: (Config.get('app_id') || 'vimmi.' + this.deviceType).toUpperCase(),
                            app_version: Config.get('app_version'),
                            sdk_version: Config.get('sdk_version')
                        };
                        return [4 /*yield*/, this.deviceType()];
                    case 2:
                        _b.device_type = _c.sent(),
                            _b.device_id = Config.get('device_id'),
                            _b.app_language = Config.get('language');
                        return [4 /*yield*/, this.shoprzDeviceInfo()];
                    case 3:
                        _b.device_info = _c.sent();
                        return [4 /*yield*/, deviceAsync.getOsName()];
                    case 4:
                        _a = ((_c.sent()) || 'unknown') + ':';
                        return [4 /*yield*/, deviceAsync.getOsVersion()];
                    case 5:
                        data = (_b.os = _a + ((_c.sent()) || 'unknown'),
                            _b.orientation = screenMode(),
                            _b);
                        if (options.buffer_timestamp) {
                            data.ts = Config.get('drivers.shoprz.timeFormat') === 'ms' ? options.buffer_timestamp : options.buffer_timestamp / 1000;
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ShoprzDriver.prototype.handlePackage = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._buffer.length) return [3 /*break*/, 2];
                        this.$logger.p('handlePackage').log('buffer:', __spreadArray([], this._buffer, true));
                        localStore.set(this.storageKey, []);
                        return [4 /*yield*/, this.sendToBackend(this._buffer.splice(0, this.options.packageOpt.maxEvents), options)];
                    case 1:
                        res = _a.sent();
                        this.$logger.p('handlePackage')
                            .log('events that remained in the buffer:', this._buffer.length, __spreadArray([], this._buffer, true), res);
                        return [2 /*return*/, res];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ShoprzDriver.prototype.sendToBackend = function (eventData, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, blob, res;
            var _this = this;
            return __generator(this, function (_a) {
                // if (Config.get('drivers.shoprz.buhsy') === false) {
                //   return null
                // }
                options = options || {};
                url = this.formatBackendUrl(options.package ? 'package' : eventData.evn, !!options.package);
                if (options.beacon && navigator.sendBeacon && !Config.get('drivers.shoprz.headers')) {
                    this.$logger.p('sendToBackend beacon')
                        .debug("Sending ".concat(options.package ? 'package' : '', " as beacon, events: \n").concat(JSON.stringify(eventData, null, ' ')));
                    blob = new Blob([JSON.stringify(eventData)], {
                        type: 'text/plain; charset=UTF-8'
                    });
                    res = navigator.sendBeacon(url, blob);
                    this.$logger.p('sendToBackend beacon').info("beacon res", res);
                    return [2 /*return*/, res];
                }
                else {
                    this.$logger.p('sendToBackend fetch')
                        .info("Sending ".concat(options.package ? 'package' : '', " events: \n").concat(JSON.stringify(eventData, null, ' ')));
                    return [2 /*return*/, doFetch(url, {
                            headers: Config.get('drivers.shoprz.headers') || {},
                            method: 'post',
                            keepalive: true,
                            body: JSON.stringify(eventData)
                        })
                            .then(function (result) {
                            return true;
                        })
                            .catch(function (error) {
                            if (Config.get('debug')) {
                                _this.$logger.p('sendToBackend fetch').error(error);
                            }
                            throw error;
                        })];
                }
            });
        });
    };
    ShoprzDriver.prototype.send = function (event, extra_data, options) {
        if (extra_data === void 0) { extra_data = null; }
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var eventData, _a, _b, _c, mapOpt, key, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // if (Config.get('drivers.shoprz.buhsy') === false) {
                        //   return
                        // }
                        if (!SHOPRZ_EVENTS_MAP[event]) {
                            this.$logger.p('send').warn("the \"ShoprzDriver\" driver doesn't support this event: ".concat(event));
                            return [2 /*return*/, false];
                        }
                        options = options || {};
                        _b = (_a = Object).assign;
                        _c = [{}];
                        return [4 /*yield*/, this.prepareEventData(event, options)];
                    case 1:
                        eventData = _b.apply(_a, _c.concat([_d.sent(), extra_data]));
                        if (Config.get('drivers.shoprz.mapOptions')) {
                            mapOpt = Config.get('drivers.shoprz.mapOptions');
                            for (key in mapOpt) {
                                if (eventData[key]) {
                                    eventData[mapOpt[key]] = eventData[key];
                                    delete eventData[key];
                                }
                            }
                        }
                        if (!this.packaging) return [3 /*break*/, 5];
                        this._buffer.push(eventData);
                        if (!(this._buffer.length >= this.options.packageOpt.minEvents || options.beacon)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handlePackage(__assign({ package: true }, options))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result];
                    case 3:
                        localStore.set(this.storageKey, JSON.stringify(this._buffer));
                        _d.label = 4;
                    case 4: return [2 /*return*/, {
                            buffered: true
                        }];
                    case 5: return [2 /*return*/, this.sendToBackend(eventData, options)];
                }
            });
        });
    };
    ShoprzDriver.prototype.beforePageClose = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.packaging /*&& Config.get('drivers.shoprz.buhsy') !== false*/) {
                    this.$logger.p('beforePageClose').log('buffer:', __spreadArray([], this._buffer, true));
                    return [2 /*return*/, this.handlePackage(Object.assign({ beacon: true, fetch: false, package: true }, options))];
                }
                return [2 /*return*/, null];
            });
        });
    };
    ShoprzDriver.prototype.formatBackendUrl = function (evn, isPackage) {
        var url = "".concat(getCurrentProtocol(), "//").concat(normDomain(Config.get('drivers.shoprz.ep'))).concat(Config.get('drivers.shoprz.customPath') || '/event/evn/');
        return url + (Config.get('NODE_ENV') === 'development' && !isPackage && !Config.get('drivers.shoprz.customPath') ? "?evn=".concat(evn) : '');
    };
    ShoprzDriver.prototype.destroy = function () {
        this.disablePackaging();
    };
    return ShoprzDriver;
}());

var VimmiAnalytics = /** @class */ (function (_super) {
    __extends(VimmiAnalytics, _super);
    function VimmiAnalytics() {
        var _this = _super.call(this) || this;
        _this.$logger = $logger;
        _this.drivers = {};
        _this.driversSetup = false;
        Config.set('sdk_version', "2.0.98");
        Config.set('buildDate', "2024-04-16T15:56:48.811Z");
        Config.set('NODE_ENV', "production");
        _this.$logger.force().groupCollapsed("VimmiAnalyticsIntegration Version: ".concat(Config.get('sdk_version')));
        _this.$logger.force().info("Build Date: ".concat(Config.get('buildDate')));
        _this.$logger.force().groupEnd();
        return _this;
    }
    VimmiAnalytics.prototype.conf = function (first, second, driver) {
        if (typeof first === 'string' && second) {
            Config.set(first, second);
        }
        else if (typeof first === 'object' && !second) {
            if (driver && Object.values(VimmiAnalytics.DRIVERS).indexOf(driver) !== -1) {
                Config.set("drivers.".concat(driver), first);
                if (this.drivers[driver]) {
                    this.drivers[driver].applyConf();
                }
            }
            else if (!driver) {
                Config.set(first);
            }
        }
        if (Config.get('language')) {
            Config.set('language', normalizeLang(Config.get('language'), 'iso-3'));
        }
        if (Config.get('device_id')) {
            this.freeBuffer();
        }
    };
    VimmiAnalytics.prototype.debug = function (status) {
        if (status === void 0) { status = null; }
        if (!status) {
            status = StyledLogger.TRACE_LEVEL;
        }
        else if (status === true) {
            status = StyledLogger.DEBUG_LEVEL;
        }
        if (Number.isInteger(status) && isFinite(status)) {
            this.$logger.config.set('debug.level', status);
            return Config.set('debug', status);
        }
    };
    VimmiAnalytics.prototype.get = function (key) {
        return Config.get(key);
    };
    VimmiAnalytics.prototype.setDriver = function (driver, options, constructorOptions) {
        if (driver === void 0) { driver = null; }
        if (options === void 0) { options = {}; }
        if (constructorOptions === void 0) { constructorOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = options || {};
                        if (!(driver && Object.values(VimmiAnalytics.DRIVERS).indexOf(driver) !== -1)) return [3 /*break*/, 2];
                        Config.set("drivers.".concat(driver), options);
                        if (VimmiAnalytics.DRIVERS.BUH === driver) {
                            if (!this.drivers[driver]) {
                                this.drivers[driver] = new BuhDriver(constructorOptions);
                            }
                        }
                        else if (VimmiAnalytics.DRIVERS.SHOPRZ === driver) {
                            if (!this.drivers[driver]) {
                                this.drivers[driver] = new ShoprzDriver(constructorOptions);
                            }
                        }
                        else if (VimmiAnalytics.DRIVERS.FBQ === driver) {
                            if (!this.drivers[driver]) {
                                this.drivers[driver] = new FBQDriver();
                            }
                        }
                        else if (VimmiAnalytics.DRIVERS.GTM === driver) {
                            if (!this.drivers[driver]) {
                                this.drivers[driver] = new GTMDriver();
                            }
                        }
                        return [4 /*yield*/, this.drivers[driver].applyConf()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    VimmiAnalytics.prototype.delDriver = function (driver) {
        if (driver === void 0) { driver = null; }
        if (driver && this.drivers[driver]) {
            this.drivers[driver].destroy();
            delete this.drivers[driver];
            return true;
        }
        return false;
    };
    /**
     * need to call after all drivers initialization
     * */
    VimmiAnalytics.prototype.initialize = function () {
        if (!Object.keys(this.drivers).length) {
            return new Error('No one driver was set up!');
        }
        this.driversSetup = true;
        this.freeBuffer();
        return null;
    };
    VimmiAnalytics.prototype.send = function (event, extraData, options) {
        if (extraData === void 0) { extraData = {}; }
        if (options === void 0) { options = {}; }
        if (!this.driversSetup || !Object.keys(this.drivers).length) {
            options.buffer_timestamp = options.buffer_timestamp || Date.now();
            this.putInbBuffer([event, extraData, options]);
        }
        else {
            options = options || {};
            for (var driver in this.drivers) {
                if (this.drivers[driver] && (!options.only || options.only.indexOf(driver) !== -1)) {
                    if ((driver === 'buh' || driver === 'shoprz') && !Config.get('device_id')) { // need to wait device_id generation complete
                        options.buffer_timestamp = options.buffer_timestamp || Date.now();
                        this.putInbBuffer([event, extraData, options]);
                    }
                    else {
                        this.drivers[driver].send(event, extraData || {}, options);
                    }
                }
            }
        }
    };
    /**
     * @description need to send drivers buffered events before page close, or need just to send some event with 'beacon': true
     * */
    VimmiAnalytics.prototype.beforePageClose = function (options) {
        if (options === void 0) { options = {}; }
        var promises = [];
        if (!this.driversSetup) {
            return false;
        }
        this.freeBuffer();
        for (var type in this.drivers) {
            if (this.drivers[type] && this.drivers[type].beforePageClose) {
                promises.push(this.drivers[type].beforePageClose(options));
            }
        }
        return Promise.all(promises);
    };
    VimmiAnalytics.prototype.getEventType = function (event) {
        return event ? BUH_EVENTS_MAP[event] || FBQ_EVENTS_MAP[event] || GTM_EVENTS_MAP[event] || null : null;
    };
    VimmiAnalytics.DRIVERS = {
        SHOPRZ: 'shoprz',
        BUH: 'buh',
        FBQ: 'fbq',
        GTM: 'gtm'
    };
    return VimmiAnalytics;
}(Buffer));

// import "core-js/stable/object/values";
// import "core-js/stable/object/assign";
// import "core-js/stable/object/keys";

export { VimmiAnalytics as default };
